import { Stack, Typography } from "@mui/material";
import JobBoardNavbar from "../components/JobBoardHomepage/JobBoardNavbar";
import EmpowerYourCareerSection from "../components/JobBoardHomepage/EmpowerYourCareer/EmpowerYourCareerSection";
import ReviewsSection from "../components/JobBoardHomepage/ReviewsSection/ReviewsSection";
import FeaturedJobsSection from "../components/JobBoardHomepage/FeaturedJobs/FeaturedJobsSection";
import TopCompaniesSection from "../components/JobBoardHomepage/TopCompanies/TopCompaniesSection";
import ExploreOurJobsection from "../components/JobBoardHomepage/ExploreOurJobCategories/ExploreOurJobSection";
import ReadyToTakeSection from "../components/JobBoardHomepage/ReadyToTake/ReadyToTakeSection";
import WeHelpJobSeekersSection from "../components/JobBoardHomepage/WeHelpJobSeekers/WeHelpJobSeekersSection";
import MostPopularJobSection from "../components/JobBoardHomepage/MostPopularJob/MostPopularJobSection";
import JoinPitchersTodaySection from "../components/JobBoardHomepage/JoinPitchersToday/JoinPitchersTodaySection";
import BlogAndNewsSection from "../components/JobBoardHomepage/BlogAndNews/BlogAndNewsSection";
import FAQsSection from "../components/JobBoardHomepage/FAQs/FAQsSection";
import FooterSection from "../components/JobBoardHomepage/Footer/FooterSection";
import { useDarkMode } from "../contexts/useDarkModeContext";


function JobBoardHomepage() {
  const { darkMode } = useDarkMode();
  return (
    <Stack sx={{ bgcolor: darkMode ? "#1c1c1c" : "#ffffff" }}>
      <JobBoardNavbar />
      <EmpowerYourCareerSection />
      {/* <ReviewsSection /> */}
      <FeaturedJobsSection />
      <TopCompaniesSection />
      <ExploreOurJobsection />
      <ReadyToTakeSection />
      <WeHelpJobSeekersSection />
      <MostPopularJobSection />
      <JoinPitchersTodaySection />
      <BlogAndNewsSection />
      <FAQsSection />
      <FooterSection />
    </Stack>
  );
}

export default JobBoardHomepage;
